import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'components/Common/MUIModal/Modal';
import ModalHeader from 'components/Common/MUIModal/ModalHeader';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ModalAddToCartError({
  isOpen,
  onClose,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onCloseClickAway={onClose}>
      <ModalHeader onClose={onClose}>
        {t('MODAL_ADD_TO_CART_PRODUCT_DEFAULT_ERROR_MESSAGE')}
      </ModalHeader>
    </Modal>
  );
}
